module.exports = __webpack_public_path__ + "static/img/kids-img-04@w.8564eb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/kids-img-04@w.jpg
// module id = lWpU
// module chunks = 0